import { render, staticRenderFns } from "./select_ambassador.vue?vue&type=template&id=6ca71c5c&scoped=true"
import script from "./select_ambassador.vue?vue&type=script&lang=js"
export * from "./select_ambassador.vue?vue&type=script&lang=js"
import style0 from "./select_ambassador.vue?vue&type=style&index=0&id=6ca71c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca71c5c",
  null
  
)

export default component.exports